module.exports = __webpack_public_path__ + "static/create-de4bc442ed4a43b83f539bd20c090f2d.png";